<form [formGroup]="generateKeyForm" class="flex flex-col h-full">
  <!-- Form Content -->
  <div class="flex-1 mt-6">
    <!-- Current Encryption Key Input -->
    <lib-input
      controlName="currentKey"
      label="Current Encryption Key"
      placeholder="Enter your current encryption key"
      [disabled]="isGenerating() || isSubmitting()" />

    <!-- Error Message -->
    @if (errorMessage()) {
    <p class="mt-1 text-xs text-typography-destructive-primary">
      {{ errorMessage() }}
    </p>
    }
  </div>

  <!-- Warning Alert (Only visible after key is generated) -->
  @if (isKeyGenerated()) {
  <div class="mb-3">
    <app-inline-alert
      type="warning"
      title="Warning"
      message="After downloading this key, Make Sure to click on 'Submit' to apply new encryption" />
  </div>
  }

  <!-- Action Buttons -->
  @let isGeneratingValue = isGenerating(); @let isSubmittingValue =
  isSubmitting(); @let keyGenerated = isKeyGenerated(); @let isFormInvalid =
  generateKeyForm.invalid; @if (!keyGenerated) {
  <!-- Before key generation: Show Close + Generate -->
  @let actionButtons = [{ id: 'close-btn', label: 'Close', variant:
  asActionButtonVariant('secondary'), disabled: isGeneratingValue }, { id:
  'generate-key-btn', label: isGeneratingValue ? 'Generating...' : 'Generate New
  Key', variant: asActionButtonVariant('primary'), disabled: isGeneratingValue
  || isFormInvalid, loading: isGeneratingValue }];

  <app-action-buttons
    [buttons]="actionButtons"
    (buttonClick)="onActionButtonClick($event)" />
  } @else {
  <!-- After key generation: Show Close + Submit -->
  @let actionButtons = [{ id: 'close-btn', label: 'Close', variant:
  asActionButtonVariant('secondary'), disabled: isSubmittingValue }, { id:
  'submit-key-btn', label: isSubmittingValue ? 'Applying...' : 'Submit',
  variant: asActionButtonVariant('primary'), disabled: isSubmittingValue,
  loading: isSubmittingValue }];

  <app-action-buttons
    [buttons]="actionButtons"
    (buttonClick)="onActionButtonClick($event)" />
  }
</form>
